<template>
  <div>
    <div v-for="section in sections" :key="section.id">
      <div
        :class="`BgEmotionChartLabels ${
          currentSection === section.id ? 'active' : ''
        }`"
        v-bind:style="{
          left: getLeft(section.timestamp_start),
        }"
      ></div>
      <div
        :class="`BgEmotionChartLabels--current-section ${
          currentSection === section.id ? 'active' : ''
        }`"
        v-bind:style="{
          left: getLeft(section.timestamp_start),
          width: getWidth(section.timestamp_start, section.timestamp_end),
        }"
      ></div>
      <div
        :class="`BgEmotionChartLabels ${
          currentSection === section.id ? 'active' : ''
        }`"
        v-bind:style="{
          left: getLeft(section.timestamp_end),
        }"
      ></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "./styles.scss";
</style>

<script>
import moment from "moment";
export default {
  name: "sections",
  props: {
    data: Object,
    duration: Number,
    currentTime: Number,
  },
  data() {
    return {
      sections: this.data.sections.filter((s) => s.label),
      currentSection: null,
    };
  },
  methods: {
    getLeft(start) {
      const diff = moment(start).diff(this.data.started_at, "milliseconds");
      return (diff / (this.duration * 1000)) * 100 + "%";
    },
    getWidth(start, end) {
      const diffStart = moment(start).diff(
        this.data.started_at,
        "milliseconds"
      );
      const diffEnd = moment(end).diff(this.data.started_at, "milliseconds");
      return ((diffEnd - diffStart) / (this.duration * 1000)) * 100 + "%";
    },
    setCurrentSection(newTime) {
      const currentTime = moment(this.data.started_at).add(
        newTime * 1000,
        "milliseconds"
      );
      const activeSection = this.sections.find((s) => {
        return currentTime.isBetween(s.timestamp_start, s.timestamp_end);
      });
      this.currentSection = activeSection ? activeSection.id : null;
    },
  },
  watch: {
    currentTime: function (newTime) {
      this.setCurrentSection(this.currentTime);
    },
  },
  mounted() {
    this.setCurrentSection(this.currentTime);
  },
};
</script>
